import HTTP from "../HTTP";

export default {
  async index(page) {
    try {
      let results = await HTTP.normal.get(
        `/countries?page%5Bnumber%5D=${page}`
      );
      return {
        data: results.data.data,
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os países!";
    }
  },

  async all() {
    try {
      let results = await HTTP.normal.get(`/countries?page%5Blimit%5D=1000`);
      return {
        data: results.data.data,
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar todos os países!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/countries.js